export const messages = {
  title: {
    id: 'admin/promotions.form.progressive-discount.title',
  },
  validation: {
    empty: {
      id: 'admin/promotions.form.group-box.validation.empty',
    },
    generic: {
      id: 'admin/promotions.form.group-box.validation.generic',
    },
  },
}
